import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col } from 'antd';
import { Modal } from 'antd-mobile';
import { withTranslation } from 'react-i18next';
import Format from '../../utils/format';
import * as SignalR from '@aspnet/signalr';

const confirmAlert = Modal.alert;
const REACT_APP_SIGNALR_URL = `${process.env.REACT_APP_STAYMENU_API_URL}/stayMenuHub`;

@inject(
  'templateStore',
  'CmsLanguageStore',
  'webSettingStore',
  'CmsMenuStore',
  'CmsClimateStore'
)
@observer
class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount() {
    this.props.templateStore.getActive();
    this.props.CmsMenuStore.getActives();

    let connection = new SignalR.HubConnectionBuilder().withUrl(REACT_APP_SIGNALR_URL).build();
    connection.start().catch(function (err) { return console.error(err.toString()); });
    connection.on(`SignalR_SyncData`, () => { window.location.reload(true); });
  }

  componentWillUnmount() {
  }

  // ON CLICK

  menuSoonClick = () => {
    const { activeTemplate } = this.props.templateStore;
    const { data: webSetting } = this.props.webSettingStore;
    confirmAlert('',
      <div
        style={{
          fontFamily: activeTemplate.templateSetting.text.fontFamily,
          color: activeTemplate.templateSetting.text.color,
          fontSize: activeTemplate.templateSetting.text.fontSize,
          lineHeight: `${activeTemplate.templateSetting.text.fontSize + 6}px`,
          textAlign: 'center'
        }}
      >
        <span>Available Soon</span>
      </div>,
      [
        {
          text: webSetting.okText
        }
      ]);
  }

  menuClick = (taskID, menuType, isSoon, redirectUrl) => {
    const {
      activeLanguages
    } = this.props.CmsLanguageStore;

    const lang = window.localStorage.getItem('lang') || 'en';
    let languageId = 1;
    if (lang && activeLanguages.length > 0) {
      const language = activeLanguages.find(fi => fi.code === lang);
      if (language) {
        languageId = activeLanguages.find(fi => fi.code === lang).id;
      }
    }

    if (isSoon) {
      this.menuSoonClick();
    } else {
      switch (menuType) {
        case 'AMENITY':
          this.props.history.push(`amenity`);
          break;

        case 'HK_SERVICE':
        case 'CONCIERGE':
        case 'DEFECT_REPORT':
        case 'DND':
        case 'FRONT_OFFICE':
        case 'LATE_CHECKOUT':
          this.props.history.push(`single-list/${taskID}/language/${languageId}`);
          break;

        case 'BOOKING_FACILITY':
          this.props.history.push(`booking`);
          break;

        case 'IN_ROOM_DINING':
          this.props.history.push(`fnb`);
          break;

        case 'IN_ROOM_DINING_URL':
          if (redirectUrl) {
            window.open(redirectUrl, '_blank');
          } else {
            console.warn('Redirect URL is not configured for this menu');
          }
          break;

        case 'LAUNDRY':
          this.props.history.push(`laundry`);
          break;

        case 'PRINT_FILE':
          this.props.history.push(`print-file`);
          break;

        case 'RCU_CONTROL':
          this.props.history.push(`rcu-control`);
          break;

        case 'SHOPPING':
          this.props.history.push(`shopping`);
          break;

        case 'SPA':
          this.props.history.push(`spa`);
          break;

        case 'TRANSPORTATION':
          this.props.history.push(`transportation`);
          break;

        case 'TV_CHANNEL':
          this.props.history.push(`tv-channel`);
          break;

        case 'WAKE_UP_CALL':
          this.props.history.push(`wakeup-call`);
          break;

        default:
          break;
      }
    }
  }

  // ON RENDER

  getCheckinTimeOnRender = () => {
    let checkinTime = localStorage.getItem('checkinTime');

    if (checkinTime) {
      if (checkinTime !== 'null') {
        return checkinTime.replace(/^"(.*)"$/, '$1');
      }
    }

    return '-';
  }

  getCheckoutTimeOnRender = () => {
    let checkoutTime = localStorage.getItem('checkoutTime');

    if (checkoutTime) {
      if (checkoutTime !== 'null') {
        return checkoutTime.replace(/^"(.*)"$/, '$1');
      }
    }

    return '-';
  }

  render() {
    const { activeTemplate } = this.props.templateStore;
    const { data: webSettting } = this.props.webSettingStore;
    const showHeaderFooter = localStorage.getItem('showHeaderFooter');
    const checkinTime = this.getCheckinTimeOnRender();
    const checkoutTime = this.getCheckoutTimeOnRender();
    const lang = window.localStorage.getItem('lang') || 'en';
    const todayLang = Format.DateTimeDayLocale(new Date());
    const roomNo = JSON.parse(localStorage.getItem('roomNo'));
    const { defaultLang, main, description, temp, cityName, icon } = this.props.CmsClimateStore;
    const { data: activeMenus } = this.props.CmsMenuStore;
    const { activeLanguages } = this.props.CmsLanguageStore;

    let languageId = 1;
    if (lang && activeLanguages.length > 0) {
      const language = activeLanguages.find(fi => fi.code === lang);
      if (language) {
        languageId = activeLanguages.find(fi => fi.code === lang).id;
      }
    }

    return (
      <>
        {
          activeTemplate
            ?
            <>
              {/* Header & Menu */}
              {
                webSettting
                  ?
                  <>
                    <Row className={'stm-margin-top-50 stm-width-100-percent'}>
                      <Col
                        span={24}
                        className='stm-width-100-percent stm-height-auto stm-padding-20 stm-background-size-cover'
                      >
                        <Row>
                          {/* <Col span={24} className='stm-font-size-24 stm-font-weight-bold'
                            style={{
                              color: activeTemplate.templateSetting.homeHeader.color,
                            }}
                          >Good Morning</Col> */}
                          <Col span={24} className='stm-font-size-14 stm-font-weight-bold'
                            style={{
                              color: activeTemplate.templateSetting.homeHeader.color,
                            }}
                          >Enjoy your stay with us</Col>

                          {/* 天气卡片 */}
                          <Row>
                          <Col
                            span={24}
                            className='stm-margin-top-10'
                            style={{
                              background: 'rgba(255, 255, 255, 0.12)',
                              backdropFilter: 'blur(1px)',
                              WebkitBackdropFilter: 'blur(10px)',
                              border: '1px solid rgba(255, 255, 255, 0.2)',
                              borderRadius: '20px',
                              padding: '12px',
                              maxWidth: '180px',
                            }}
                          >
                            {
                              temp
                                ?
                                <>
                                  {/* 城市名称 */}
                                  <Row style={{ display: 'flex'}} className='stm-margin-bottom-8'>
                                    <Col flex="none">
                                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={activeTemplate.templateSetting.homeInfo.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                                        <circle cx="12" cy="10" r="3"></circle>
                                      </svg>
                                    </Col>
                                    <Col flex="none">
                                      <span style={{ marginLeft: '4px', fontFamily: activeTemplate.templateSetting.homeInfo.fontFamily, color: activeTemplate.templateSetting.homeInfo.color, fontSize: activeTemplate.templateSetting.homeInfo.fontSize }}
                                      >{cityName}</span>
                                    </Col>
                                  </Row>

                                  {/* 天气信息 */}
                                  <Row style={{ display: 'flex', alignItems: 'center' }} className='stm-margin-bottom-8'>
                                    <Col span={8}>
                                      {
                                        icon
                                          ? <img src={icon} style={{ width: 52, height: 52 }} alt='weather-icon' />
                                          : null
                                      }
                                    </Col>
                                    <Col span={18}>
                                      <Row>
                                        <Col span={24}>
                                          <span
                                            style={{
                                              fontFamily: activeTemplate.templateSetting.homeHeader.fontFamily,
                                              color: activeTemplate.templateSetting.homeHeader.color,
                                              fontSize: '26px',
                                              fontWeight: 'bold',
                                              lineHeight: 1,
                                            }}
                                          >{Math.ceil(temp)}&deg;</span>
                                        </Col>
                                        <Col span={24}>
                                          <span
                                            style={{
                                              fontFamily: activeTemplate.templateSetting.homeInfo.fontFamily,
                                              color: activeTemplate.templateSetting.homeInfo.color,
                                              fontSize: activeTemplate.templateSetting.homeInfo.fontSize,
                                            }}
                                          >{defaultLang ? main : description}</span>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>

                                  {/* 日期 */}
                                  <Row style={{ display: 'flex' }} className='stm-margin-bottom-8'>
                                    <Col flex="none">
                                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={activeTemplate.templateSetting.homeInfo.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                        <line x1="16" y1="2" x2="16" y2="6"></line>
                                        <line x1="8" y1="2" x2="8" y2="6"></line>
                                        <line x1="3" y1="10" x2="21" y2="10"></line>
                                      </svg>
                                    </Col>
                                    <Col flex="none">
                                      <span style={{ marginLeft: '4px', fontFamily: activeTemplate.templateSetting.homeInfo.fontFamily, color: activeTemplate.templateSetting.homeInfo.color, fontSize: activeTemplate.templateSetting.homeInfo.fontSize }}
                                      >{todayLang}</span>
                                    </Col>
                                  </Row>

                                  {/* 时间 */}
                                  <Row style={{ display: 'flex'}}>
                                    <Col flex="none" >
                                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={activeTemplate.templateSetting.homeInfo.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="12" r="10"></circle>
                                        <polyline points="12 6 12 12 16 14"></polyline>
                                      </svg>
                                    </Col>
                                    <Col flex="none" style={{ marginLeft: '4px'}}>
                                      <span
                                        style={{
                                          fontFamily: activeTemplate.templateSetting.homeInfo.fontFamily,
                                          color: activeTemplate.templateSetting.homeInfo.color,
                                          fontSize: activeTemplate.templateSetting.homeInfo.fontSize,
                                        }}
                                      >{new Date().toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })}</span>
                                    </Col>
                                  </Row>
                                </>
                                :
                                null
                            }
                          </Col>
                          </Row>
                        </Row>
                      </Col>
                    </Row>
                  </>
                  :
                  null
              }
            </>
            :
            null
        }
      </>
    )
  }
}

export default withTranslation()(Home)
